<script setup lang="ts">
definePageMeta({
  middleware: ['03-pharmacy-related'],
})
</script>

<template>
  <p>{{ $route.name }}</p>
</template>
